// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { CheckIcon } from '@radix-ui/react-icons';

interface CustomCheckboxProps {
  defaultChecked?: boolean;
  checked?: boolean;
  onCheckedChange: (v: boolean) => void;
}

export const Checkbox = ({ defaultChecked, checked, onCheckedChange }: CustomCheckboxProps) => (
  <div className="flex items-center space-x-2">
    <RadixCheckbox.Root
      checked={checked}
      defaultChecked={!!defaultChecked}
      onCheckedChange={onCheckedChange}
      className="w-5 h-5 flex items-center justify-center bg-gray-100 border border-gray-300 rounded transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >
      <RadixCheckbox.Indicator>
        <CheckIcon className="text-blue-500" />
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  </div>
);
